
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/return",
      function () {
        return require("private-next-pages/article/return.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/return"])
      });
    }
  